module.exports = __webpack_public_path__ + "static/media/clock.f8a261d2.svg";